import React, {  useEffect } from 'react'
import Adress from '../component/Adress'
import My from '../component/My'
import Security from '../component/Security'
import Services from '../component/Services'
import './style.css'
export default function Profil() {
  const token=localStorage.getItem('token')

  useEffect(() => {
    if (typeof window != 'undefined' && !token) {
      window.location.href = '/se-connecter'
    }
  }, [token])


  return (
    <div>
      <div className="bg-gray-100 row   p-10">
       

        <div className="col-lg-6 mx-auto flex-col p-3">
        <My />
       
          <Adress />
          <Security />
          <Services />
        </div>
      </div>
    </div>
  )
}
